import { render, staticRenderFns } from "./SuccessMessage.vue?vue&type=template&id=1d6d60f8&scoped=true"
import script from "./SuccessMessage.vue?vue&type=script&lang=js"
export * from "./SuccessMessage.vue?vue&type=script&lang=js"
import style0 from "./SuccessMessage.vue?vue&type=style&index=0&id=1d6d60f8&prod&scoped=true&lang=css"
import style1 from "./SuccessMessage.vue?vue&type=style&index=1&id=1d6d60f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6d60f8",
  null
  
)

export default component.exports